
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import languageIcon from '@/assets/language-icon.png';

const LanguageToggle: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = async (value: string) => {
    console.log('[toggle] click', value);
    try {
      await i18n.changeLanguage(value);
      localStorage.setItem('i18nextLng', value); // valgfritt, for persistens
      document.documentElement.lang = value;     // nice-to-have for <html lang="">
      console.log('[toggle] i18n.language now =', i18n.language);
    } catch (e) {
      console.error('[toggle] changeLanguage failed', e);
    }
  };

  return (
    <Select value={i18n.language} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-auto h-8 px-0 border-none !bg-transparent shadow-none hover:!bg-transparent focus:ring-0 focus:ring-offset-0 [&>svg]:hidden">
        <img 
          src={languageIcon} 
          alt="Language" 
          className="w-[26px] h-[26px] opacity-90 contrast-125" 
        />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">EN - English</SelectItem>
        <SelectItem value="no">NO - Norsk</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default LanguageToggle;
